import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3517">
      <Navbar data-id="element-3518" />
      <main data-id="element-3519">
        <ConsularAffairs data-id="element-3520" />
      </main>
      <Footer data-id="element-3521" />
    </div>;
}